import { formatDateLocal } from '../../../../../lib/script'
import DownloadDocument from './controls/DownloadDocument'
import ViewDocument from './controls/ViewDocument'
import PannelBody from '../../../../fragments/PannelBody'

import classes from './DownloadConfirmation.module.css'

export default function DownloadConfirmation({closeModal, parent, file, isView, userToken, activeCase,docType}) {
 
    return <>        
        {parent && <>
            <PannelBody padding='large' background={'var(--line-transparent35)'}>
                <div className={classes.file_details_info}>
                    <div className={classes.file_name}><i className='ti ti-file-description'></i>{file.file_name}</div>
                    <div className={classes.file_author_container}>
                        <div className={classes.file_author}>By {parent.added_by}</div>
                        <div>at {formatDateLocal(parent.created_at)}</div>
                    </div>
                </div>
            </PannelBody>
            <PannelBody>
                <div className={classes.body_font}>
                    <p>This is an older version file for {parent.file_name}. </p>
                    <p className={'primary_color'}>Do you really want to {isView ? 'view' : 'download'} this file?</p>
                </div>
                
            </PannelBody>
            <PannelBody>
                {!isView && <DownloadDocument userToken={userToken} activeCase={activeCase} item={file} extraAction={closeModal} docType={docType}>
                    <i className="ti ti-download"></i>Download File
                </DownloadDocument>}
                {isView && <ViewDocument userToken={userToken} activeCase={activeCase} item={file} extraAction={closeModal} docType={docType}>
                    <i className="ti ti-eye"></i>View File    
                </ViewDocument>}
            </PannelBody>
        </>}
    </>
}